import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Pictogram from 'components/Pictogram';

const Container = styled.div`
	margin: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-items: center;
	background-color: white;
`;
const PictogramContainer = styled.div`
	width: 64px;
	height: 64px;
	margin: 0 0 16px;
`;
const Label = styled.p`
	display: block;
	text-align: center;
	word-break: break-word;
	font-size: 14px;
	user-select: none;
`;

const PictogramItem = ({ image, localName }) => {
	return (
		<Container>
			<PictogramContainer>
				<Pictogram svg={image} />
			</PictogramContainer>
			<Label>{localName}</Label>
		</Container>
	)
}

PictogramItem.propTypes = {
	image: PropTypes.string,
	localName: PropTypes.string,
}

export default PictogramItem;
